export default () => {
  // Needed to get sub menu to work in Safari
  const subMenuItems = document.querySelectorAll('.menu-item-has-children');
  subMenuItems.forEach((subMenu) => {
    subMenu.setAttribute('tabindex', '0');
  });
};
